// eslint-disable-next-line import/no-anonymous-default-export
export default {
	// 现测试地址
	BASE_URL: 'http://47.107.34.159:8083',
	SOCKET_URL: 'ws://47.107.34.159:8083/webSocket/',
	SOCKETIO_URL: 'http://47.107.34.159:9999'


	// BASE_URL: 'http://192.168.110.35:8080',
	// SOCKET_URL: 'ws://192.168.110.35:8080/webSocket/',
	// SOCKETIO_URL: 'http://192.168.110.35:9999'

	/* BASE_URL: 'http://192.168.110.7:8080',
	SOCKET_URL: 'ws://192.168.110.7:8080/webSocket/',
	SOCKETIO_URL: 'http://192.168.110.7:9999' */

	// 正式地址
	//BASE_URL: 'https://xiaoaishop.com/prod-api/',
	//SOCKET_URL: 'ws://150.158.157.212:8080/webSocket/',
	//SOCKETIO_URL: 'https://xiaoaishop.com'
}